function getValidationRules(countryCode) {
  const validationRulesUS = {
    billing_company: {
      selector: "[name='billing_company']",
      maxLength: 35
    },
    billing_first_name: {
      selector: "[name='billing_first_name']",
      required: true,
      maxLength: 20
    },
    billing_last_name: {
      selector: "[name='billing_last_name']",
      required: true,
      maxLength: 20
    },
    billing_address_1: {
      selector: "[name='billing_address_1']",
      required: true,
      maxLength: 35
    },
    billing_address_2: {
      selector: "[name='billing_address_2']",
      maxLength: 30
    },
    billing_city: {
      selector: "[name='billing_city']",
      required: true,
      type: "alphabetical",
      maxLength: 30
    },
    billing_state: {
      selector: "[name='billing_state']",
      required: true
    },
    billing_postcode: {
      selector: "[name='billing_postcode']",
      required: true,
      postalCodePattern: "(^\\d{5}$)|(^\\d{5}-\\d{4}$)|(^\\d{9}$)",
      maxLength: 10
    },
    billing_phone: {
      selector: "[name='billing_phone']",
      required: true,
      type: "numeric",
      maxLength: 18
    },
    billing_email: {
      selector: "[name='billing_email']",
      required: true,
      type: "email",
      maxLength: 100
    },
    billing_tax_information: {
      selector: "[name='billing_tax_information']",
      type: 'numeric',
      maxLength: 9
    },
    shipping_company: {
      selector: "[name='shipping_company']",
      maxLength: 35
    },
    shipping_first_name: {
      selector: "[name='shipping_first_name']",
      required: true,
      maxLength: 20
    },
    shipping_last_name: {
      selector: "[name='shipping_last_name']",
      required: true,
      maxLength: 20
    },
    shipping_address_1: {
      selector: "[name='shipping_address_1']",
      required: true,
      maxLength: 35
    },
    shipping_address_2: {
      selector: "[name='shipping_address_2']",
      maxLength: 30
    },
    shipping_city: {
      selector: "[name='shipping_city']",
      required: true,
      type: "alphabetical",
      maxLength: 30
    },
    shipping_state: {
      selector: "[name='shipping_state']",
      required: true
    },
    shipping_postcode: {
      selector: "[name='shipping_postcode']",
      required: true,
      postalCodePattern: "(^\\d{5}$)|(^\\d{5}-\\d{4}$)|(^\\d{9}$)",
      maxLength: 10
    },
    terms: {
      selector: "[name='terms']",
      required: true
    }
  }

  const validationRulesCA = {
    billing_company: {
      selector: "[name='billing_company']",
      maxLength: 35
    },
    billing_first_name: {
      selector: "[name='billing_first_name']",
      required: true,
      maxLength: 20
    },
    billing_last_name: {
      selector: "[name='billing_last_name']",
      required: true,
      maxLength: 20
    },
    billing_address_1: {
      selector: "[name='billing_address_1']",
      required: true,
      maxLength: 35
    },
    billing_address_2: {
      selector: "[name='billing_address_2']",
      maxLength: 30
    },
    billing_city: {
      selector: "[name='billing_city']",
      required: true,
      type: "alphabetical",
      maxLength: 30
    },
    billing_state: {
      selector: "[name='billing_state']",
      required: true
    },
    billing_postcode: {
      selector: "[name='billing_postcode']",
      required: true,
      postalCodePattern: "^(?!.*[DFIOQU])[A-VXY][0-9][A-Z]\\s?[0-9][A-Z][0-9]$",
      maxLength: 7
    },
    billing_phone: {
      selector: "[name='billing_phone']",
      required: true,
      type: "numeric",
      maxLength: 18
    },
    billing_email: {
      selector: "[name='billing_email']",
      required: true,
      type: "email",
      maxLength: 100
    },
    billing_tax_information: {
      selector: "[name='billing_tax_information']",
      type: 'numeric',
      maxLength: 9
    },
    shipping_company: {
      selector: "[name='shipping_company']",
      maxLength: 35
    },
    shipping_first_name: {
      selector: "[name='shipping_first_name']",
      required: true,
      maxLength: 20
    },
    shipping_last_name: {
      selector: "[name='shipping_last_name']",
      required: true,
      maxLength: 20
    },
    shipping_address_1: {
      selector: "[name='shipping_address_1']",
      required: true,
      maxLength: 35
    },
    shipping_address_2: {
      selector: "[name='shipping_address_2']",
      maxLength: 30
    },
    shipping_city: {
      selector: "[name='shipping_city']",
      required: true,
      type: "alphabetical",
      maxLength: 30
    },
    shipping_state: {
      selector: "[name='shipping_state']",
      required: true
    },
    shipping_postcode: {
      selector: "[name='shipping_postcode']",
      required: true,
      postalCodePattern: "^(?!.*[DFIOQU])[A-VXY][0-9][A-Z]\\s?[0-9][A-Z][0-9]$",
      maxLength: 7
    },
    terms: {
      selector: "[name='terms']",
      required: true
    }
  }

  if (countryCode === 'us') {
    return validationRulesUS;
  } else if (countryCode === 'ca') {
    return validationRulesCA;
  }

}

export {
  getValidationRules
};
